<div class="space-y-5">
  <div class="flex items-center justify-between">
    <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide">Precios Escalonados</h3>
    @if (tiers.length > 0) {
      <button type="button" (click)="eliminarTodos()"
        class="px-2.5 py-1 text-xs rounded-md font-medium bg-error-50 text-error-600 hover:bg-error-100 dark:bg-error-900/20 dark:text-error-400 dark:hover:bg-error-900/40">
        Eliminar todos
      </button>
    }
  </div>

  @if (error) {
  <div class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-900/20 dark:border-error-800">
    <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  </div>
  }

  @if (success) {
  <div class="p-3 bg-success-50 border border-success-200 rounded-lg dark:bg-success-900/20 dark:border-success-800">
    <p class="text-sm text-success-600 dark:text-success-400">{{ success }}</p>
  </div>
  }

  @if (loading) {
  <div class="flex items-center gap-2 text-gray-500 dark:text-gray-400 py-4">
    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
    <span class="text-sm">Cargando tramos...</span>
  </div>
  } @else {
  <!-- Método global -->
  <div>
    <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Método de cálculo (aplica a todos los tramos)</label>
    <select [(ngModel)]="globalPricingMethod" (ngModelChange)="onPricingMethodChange()"
      class="w-full sm:w-48 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      <option value="volume">Volumen</option>
      <option value="step">Escalonado (step)</option>
      <option value="graduated">Graduado</option>
    </select>
  </div>

  <!-- Tabla editable de tramos -->
  <div class="overflow-x-auto">
    <table class="min-w-full text-xs">
      <thead>
        <tr class="border-b border-gray-200 dark:border-gray-700">
          <th class="px-2 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Nivel</th>
          <th class="px-2 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Min. unidades</th>
          <th class="px-2 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Max. unidades</th>
          <th class="px-2 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Precio unitario</th>
          <th class="px-2 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Precio fijo</th>
          <th class="px-2 py-2"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 dark:divide-gray-700/50">
        @for (tier of editTiers; track $index) {
        <tr>
          <td class="px-2 py-1.5 text-gray-600 dark:text-gray-400 font-mono">{{ tier.tierLevel }}</td>
          <td class="px-2 py-1.5">
            <input type="number" [(ngModel)]="tier.minUnits" min="0"
              class="w-20 px-2 py-1 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-1 focus:ring-brand-500" />
          </td>
          <td class="px-2 py-1.5">
            <input type="number" [(ngModel)]="tier.maxUnits" min="0" placeholder="Sin límite"
              class="w-24 px-2 py-1 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-1 focus:ring-brand-500" />
          </td>
          <td class="px-2 py-1.5">
            <input type="number" [(ngModel)]="tier.unitPrice" min="0" step="0.01"
              class="w-24 px-2 py-1 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-1 focus:ring-brand-500" />
          </td>
          <td class="px-2 py-1.5">
            <input type="number" [(ngModel)]="tier.fixedPrice" min="0" step="0.01" placeholder="-"
              class="w-24 px-2 py-1 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-1 focus:ring-brand-500" />
          </td>
          <td class="px-2 py-1.5">
            <button type="button" (click)="quitarTramo($index)"
              class="text-gray-400 hover:text-error-500 transition-colors">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Actions -->
  <div class="flex items-center gap-2">
    <button type="button" (click)="agregarTramo()"
      class="px-2.5 py-1 text-xs rounded-md font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center gap-1">
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
      </svg>
      Agregar tramo
    </button>
    <button type="button" (click)="guardarTramos()" [disabled]="saving || editTiers.length === 0"
      class="px-3 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
      {{ saving ? 'Guardando...' : 'Guardar tramos' }}
    </button>
  </div>

  <!-- Calculadora -->
  <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
    <h4 class="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-3">Calculadora de precio</h4>
    <div class="flex items-center gap-3">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Cantidad</label>
        <input type="number" [(ngModel)]="calcQuantity" (ngModelChange)="onCalcQuantityChange()"
          (keyup.enter)="calcularPrecio()" min="1" placeholder="100"
          class="w-24 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
      </div>
      <div class="flex items-end">
        <button type="button" (click)="calcularPrecio()" [disabled]="calculating"
          class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
          {{ calculating ? 'Calculando...' : 'Calcular' }}
        </button>
      </div>
      @if (calcResult) {
      <div class="ml-4 p-3 bg-brand-50 dark:bg-brand-900/20 rounded-lg">
        <p class="text-xs text-gray-500 dark:text-gray-400">Precio total</p>
        <p class="text-lg font-bold text-brand-600 dark:text-brand-400">{{ formatPrecio(calcResult.totalPrice) }}</p>
        <p class="text-xs text-gray-500 dark:text-gray-400">Método: {{ pricingMethodLabel(calcResult.pricingMethod) }}</p>
      </div>
      } @else if (calcError) {
      <div class="ml-4 px-3 py-2 bg-warning-50 dark:bg-warning-500/10 rounded-lg">
        <p class="text-xs font-medium text-warning-700 dark:text-warning-400">{{ calcError }}</p>
      </div>
      }
    </div>

    @if (calcResult?.breakdown && calcResult!.breakdown!.length > 0) {
    <div class="mt-3 overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-xs">
        <thead class="bg-gray-50 dark:bg-gray-800/50">
          <tr>
            <th class="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Nivel</th>
            <th class="px-3 py-2 text-right font-medium text-gray-500 dark:text-gray-400">Unidades</th>
            <th class="px-3 py-2 text-right font-medium text-gray-500 dark:text-gray-400">Precio unit.</th>
            <th class="px-3 py-2 text-right font-medium text-gray-500 dark:text-gray-400">Subtotal</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-700/50">
          @for (row of calcResult!.breakdown; track row.tierLevel) {
          <tr>
            <td class="px-3 py-1.5 text-gray-600 dark:text-gray-400">{{ row.tierLevel }}</td>
            <td class="px-3 py-1.5 text-right text-gray-800 dark:text-white">{{ row.units }}</td>
            <td class="px-3 py-1.5 text-right text-gray-800 dark:text-white">{{ formatPrecio(row.unitPrice) }}</td>
            <td class="px-3 py-1.5 text-right font-medium text-brand-600 dark:text-brand-400">{{ formatPrecio(row.subtotal) }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
  }
</div>
